<template>
  <LayoutContainer :props="props" v-if="!homeInfo.isOverdue && steps.length">
    <div class="extra-award-card">
      <div class="flex-center card-header">
        <div class="flex-center">
          <span class="card-title">额外奖励</span>
          <PopoverComponent>
            <div>{{ props.popover }}</div>
          </PopoverComponent>
        </div>
        <div class="activity-time">活动时间：{{ homeInfo.ladderAwardRuleModel.startTime | formatDate }}-{{ homeInfo.ladderAwardRuleModel.endTime | formatDate }}</div>
      </div>

      <div
        class="card-body"
        id="scrollContainer"
        :style="{
          height: homeInfo.orderedNum ? px2rem(215) : px2rem(180)
        }"
      >
        <div
          class="card-body-outer"
          :class="{
            overflow: steps.length > 3
          }"
          id="scrollEl"
          :style="`width: ${cardWidth}`"
        >
          <div class="card-body-inner">
            <template v-for="(item, index) in steps">
              <div class="body-item" :key="index" :id="`ward-item_${index}`">
                <img src="@/assets/share/redpacket.png" >
                <div class="award-context">
                  <span>{{ item.awardAmount }}</span>
                  元
                </div>
                <div class="red-packet">红包券</div>
                <div class="invitation-limit">邀请{{ item.invitationLimit }}人</div>
              </div>
            </template>
          </div>

          <!-- 至少邀请一个人，才展示进度条 -->
          <div class="progress-wrap" v-if="homeInfo.orderedNum">
            <div class="progress">
              <div class="progress__portion" :style="`width: ${currentCardMid.bar}`">
                <div class="progress__pivot"></div>
              </div>
            </div>
            <div class="progress-text" :style="`marginLeft: ${currentCardMid.text}`">
              <span class="text-before" :style="`left: ${currentCardMid.textBefore}`"></span>
              <template v-if="homeInfo.nextStepNum">{{ `${homeInfo.orderedNum || 0}人已下单，还差${homeInfo.nextStepNum || 0}人` }}</template>
              <template v-else>{{ `${homeInfo.orderedNum}人已下单，恭喜达成任务` }}</template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </LayoutContainer>
</template>

<script>
import { px2rem } from '@/utils/utils';
import dayjs from 'dayjs';
import VueScrollTo from 'vue-scrollto';
import { mapState } from 'vuex';
import PopoverComponent from '@/components/popover';

export default {
  name: 'kaer-extra-award',
  components: {
    PopoverComponent
  },
  props: {
    props: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    formatDate(time) {
      return dayjs(time).format('MM.DD');
    }
  },
  computed: {
    ...mapState({
      homeInfo: state => state.share.homeInfo
    }),
    steps() {
      return this.homeInfo.ladderAwardRuleModel?.ladderAwardList || [];
    },
    currentIndex() {
      return this.homeInfo.currentStep ?? 0;
    },
    cardWidth() {
      const len = this.steps.length;
      let w = len * 84 + (len - 1) * 20;
      if (len > 3) w += 12; // 右内边距
      return this.px2rem(w);
    },
    currentCardMid() {
      let left = this.currentIndex * (84 + 20) + 42;

      let textLeft = left - 71;
      let textBefore = '50%';
      // 处理左侧被截取问题
      if (this.currentIndex === 0) {
        textLeft = 0;
        textBefore = this.px2rem(42);
        // 处理右侧被截取问题
      } else if (this.currentIndex === this.steps.length - 1) {
        textLeft -= 42;
        textBefore = this.px2rem(113);

        if (+this.homeInfo.nextStepNum === 0) {
          left += 36;
          textLeft += 6;
          textBefore = this.px2rem(140);
        }
      }
      return {
        bar: this.px2rem(left),
        text: this.px2rem(textLeft),
        textBefore
      };
    }
  },
  watch: {
    steps: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length) {
          this.$nextTick(this.initScroll);
        }
      }
    }
  },
  methods: {
    px2rem,
    initScroll() {
      try {
        const dom = document.getElementById('ward-item_1');
        const i = this.currentIndex;
        const offset = (i > 1 ? i : 0) * 104 - 134 - 104;

        const options = {
          container: document.getElementById('scrollContainer'),
          easing: 'ease-in',
          lazy: false,
          offset,
          force: true,
          cancelable: true,
          x: true,
          y: false
        };
        VueScrollTo.scrollTo(dom, 0, options);
      } catch (err) {}
    }
  }
};
</script>

<style scoped lang="less">
.extra-award-card {
  width: 100%;
  border-radius: 8px;
  background: #fff;

  .card-header {
    background: #F5F5F5;
    height: 40px;
    padding: 0 12px;
    border-radius: 8px 8px 0px 0px;
    justify-content: space-between;

    .card-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #595959;
      margin-right: 3px;
    }

    .activity-time {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8C8C8C;
    }
  }

  .card-body {
    border-radius: 0px 0px 8px 8px;
    height: 215px;
    padding: 0 12px;
    overflow-x: scroll;

    .card-body-outer {
      margin: 0 auto;

      &.overflow {
        padding-right: 12px;
      }

      .card-body-inner {
        margin-top: 32px;
        display: flex;

        .body-item {
          position: relative;
          width: 84px;
          height: 110px;
          flex-basis: 84px;
          flex-grow: 0;
          flex-shrink: 0;

          &:not(:first-child) {
            margin-left: 20px;
          }

          img {
            width: 100%;
            height: 100%;
          }

          .award-context {
            position: absolute;
            top: 8px;
            width: 100%;
            text-align: center;
            color: #fff;
            font-size: 12px;
            overflow: hidden;
            white-space: nowrap;

            span {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
            }
          }

          .red-packet {
            position: absolute;
            top: 40px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
          }

          .invitation-limit {
            position: absolute;
            top: 84px;
            width: 100%;
            text-align: center;
            color: #fff;
            font-size: 14px;
          }
        }
      }

      .progress-wrap {
        width: 100%;
        margin-top: 12px;
        position: relative;
        height: 6px;
        background: #eeeeee;
        border-radius: 3px;

        .progress {
          position: relative;
          height: 100%;

          .progress__portion {
            position: absolute;
            left: 0;
            height: 100%;
            background-color: #FC5308;
            border-radius: 3px;

            .progress__pivot {
              position: absolute;
              z-index: 2;
              right: -6px;
              top: 50%;
              transform: translateY(-50%);
              width: 12px;
              height: 12px;
              background: #FFB18F;
              border-radius: 50%;

              &::after {
                content: '';
                display: block;
                width: 6px;
                height: 6px;
                background: #FC5308;
                border-radius: 50%;
                position: absolute;
                z-index: 3;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
          }
        }

        .progress-text {
          position: relative;
          margin-top: 12px;
          display: inline-block;
          min-width: 142px;
          height: 20px;
          padding: 0 5px;
          background: #595959;
          border-radius: 10px;
          line-height: 20px;
          text-align: center;
          color: #fff;
          font-size: 12px;
          white-space: nowrap;

          .text-before {
            position: absolute;
            top: -4px;
            width: 0;
            height: 0;
            display: block;
            border: 4px solid #595959;
            border-right-color: transparent;
            border-bottom-color: transparent;
            transform: translateX(-50%) rotate(45deg);
          }
        }
      }
    }
  }
}
</style>
